import React, { useState } from "react";

export default function BillTipPercent(props) {
  const [isSelected, setIsSelected] = useState(false);
  return (
    <div
      onClick={(e) => {
        props.onSelectTip(props.tipValue);
        setIsSelected(isSelected ? false : true);
      }}
      className={`${props.tipClassName} ${!isSelected ? "" : "selected"}`}
    >
      {props.tipValue + "%"}
    </div>
  );
}
